import { track } from "../../tracker/EventTracker";
import { trackLead } from "../../tracker/Facebook";
import * as popupTracker from "./popupTracker";
import { Validator as FormValidator } from "../form/Validator";

class NewsletterValidator extends FormValidator {
	connectedCallback() {
		super.connectedCallback();
		this.querySelector("input[name=email]").addEventListener("focus", () => {
			track("Newsletter", "Klick ins Eingabefeld", this.location);
		});
	}

	onSuccess() {
		super.onSuccess();
		track("Newsletter", "Angemeldet", this.location);
		trackLead();
		popupTracker.setSignedUp();
		this.dispatchEvent(new CustomEvent("submitSuccess", { bubbles: true }));
	}

	showSuperError(errorMessage) {
		super.showSuperError(errorMessage);
		Array.from(this.form.children)
			.filter(child => !child.hasAttribute("data-form-error-message"))
			.forEach(node => node.classList.add("hidden"));
		track("Newsletter", `Fehler: ${errorMessage}`, this.location);
		this.dispatchEvent(new CustomEvent("submitError", { bubbles: true }));
	}

	renderFieldErrors(errors, status) {
		super.renderFieldErrors(errors, status);
		if (status === 409) {
			// Remember already subscribed users.
			popupTracker.setSignedUp();
		}
	}

	get location() {
		return this.getAttribute("location") || undefined;
	}
}
customElements.define("esc-newsletter-validator", NewsletterValidator);
